import type { TaskListModel } from '@models/types'

export type TemplateGroupModel = {
  id: number,
  brand_id: number,
  cache_key?: number,
  task_lists?: TaskListModel[],
  title?: string,
}

export type TemplateGroupRequestOptions = {
  include_template_group_brand: boolean,
  include_template_group_task_lists: boolean,
}

const state = {
  id: null,
  brand_id: null,
  cache_key: null,
  checklist_template_id: null,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'checklist_template_id' },
  { key: 'title' },
]

export default state
